module.exports = __webpack_public_path__ + "static/media/3.948115c6.png";